import React, { useEffect, useRef, useState } from "react";
import { useForm, Controller } from "react-hook-form";
import { Autocomplete, TextField, IconButton, Tooltip } from "@mui/material";
import ClosedIcon from "@mui/icons-material/Close";
import { callAPI } from "../../../axios";
import TableWrapper from "../../core/BaseComponents/TableWrapper/TableWrapper";
import { MdModeEditOutline } from "react-icons/md";
import DeleteIcon from "@mui/icons-material/Delete";
import BasicModal from "../../core/BaseComponents/Modal";
import deleteImg from '../../../assets/images/delete.png';
import { IoMdWarning } from "react-icons/io";

const SoftwareStackDetails = () => {
    const [loader, setLoader] = useState(false);
    const [softwareVersionResponse, setSoftwareVersionResponse] = useState([]);
    const [softwareStackCreated, setSoftwareStackCreated] = useState("");
    const [editSoftwareStack, setEditSoftwareStack] = useState(false);
    const [editSoftwareStatckSid, setEditSoftwareStatckSid] = useState({});
    const [deleteSoftwareStackPopUp, setDeleteSoftwareStackPopUp] = useState(false);
    const [confirmDeleteHotel, setConfirmDeleteHotel] = useState("");
    const [confirmValidate, setConfirmValidate] = useState(false);
    const [showRowDataPopUp, setShowRowDataPopUp] = useState(false);
    const [rowData, setRowData] = useState([]);
    const [rowKey, setRowKey] = useState("");
    const maxVisible = 3;
    const {
        // register,
        handleSubmit,
        formState: { errors },
        reset,
        control,
        // setValue,
        watch
    } = useForm({
        mode: 'onChange',
    });

    const isHotelDeletedRef = useRef({
        isHotelDeletedModalData: null,
        userConformationModalData: null,
    });


    const onSubmit = (data) => {

        let method = "POST";
        let url = "/software-versions";
        if (editSoftwareStack) {
            method = "PUT"
            url = `/software-versions?id=${editSoftwareStatckSid?.id}`
        }

        setLoader(true);
        callAPI(url, method, data)
            .then(function (response) {
                reset({
                    firmwareVersion: [],
                    kpiVersion: [],
                    tvAppVersion: [],
                    bouquetNames: [],
                });
                setSoftwareStackCreated(response?.message);
                softwareStackDetailsList();
                setEditSoftwareStatckSid({});
                setEditSoftwareStack(false);
                setLoader(false);
            })
            .catch(function (error) {
                console.warn(error.response?.data?.errorMessage);
                setLoader(false);
            });
    };

    const showPopUpHandler = (items, key) => {
        const keyNameHeader = key.split(/(?=[A-Z])/).join(' ');
        setShowRowDataPopUp(true);
        setRowData(items);
        setRowKey(keyNameHeader);
    }

    const renderVersionList = (row, key) => {
        const items = row?.[key] || [];
        const visibleItems = items.slice(0, maxVisible);
        const remainingItems = items.slice(maxVisible);

        return (
            <p className="white-space-normal">
                {visibleItems.map((item, index) => (
                    <span key={index}>{`${index ? ', ' : ''}${item}`}</span>
                ))}
                {remainingItems.length > 0 && (
                    <span className="ms-2 cdsn-count cursor-pointer" onClick={() => showPopUpHandler(items, key)}>+{remainingItems.length}</span>
                )}
            </p>
        );
    };

    const deleteSoftwareStackPopUpHandler = (row) => {
        setDeleteSoftwareStackPopUp(true);
        const newModalRefData = {
            isHotelDeletedModalData: {
                row
            },
            userConformationModalData: null,
        };
        isHotelDeletedRef.current = newModalRefData;
    }
    const deleteHotelHandler = () => {
        setConfirmValidate(true);
        if (confirmDeleteHotel === "") {
            return
        }

        if (confirmDeleteHotel === `Delete`) {
            setConfirmValidate(false)
            const { row } = isHotelDeletedRef.current?.isHotelDeletedModalData;
            setLoader(true);
            callAPI(`software-versions/${row?.id}?id=${row?.id}`, "DELETE")
                .then((response) => {
                    let successMessage = response.message
                    const newModalRefData = {
                        isHotelDeletedModalData: null,
                        userConformationModalData: {
                            successMessage
                        },
                    };
                    isHotelDeletedRef.current = newModalRefData;
                    softwareStackDetailsList();
                    setLoader(false);
                })
                .catch((error) => {
                    console.warn(error);
                    setLoader(false);
                });
        }
        reset({
            firmwareVersion: [],
            kpiVersion: [],
            tvAppVersion: [],
            bouquetNames: [],
        });
    }
    const renderActionIcon = (row) => {
        return (
            true ? <>
                <Tooltip title="Edit" arrow>
                    <MdModeEditOutline
                        className="edit-icon-enable"
                        onClick={() => { setEditSoftwareStack(true); setEditSoftwareStatckSid(row) }}
                    />
                </Tooltip>
                <Tooltip title="Delete" className="cursor-pointer" arrow>
                    <DeleteIcon
                        className="delete-icon-enable"
                        onClick={() => {
                            deleteSoftwareStackPopUpHandler(row);
                        }}
                    />
                </Tooltip></>
                : <>
                    <Tooltip title="Don't have permission to edit">
                        <span>
                            <MdModeEditOutline className="edit-icon-disable" arrow />
                        </span>
                    </Tooltip>
                    <Tooltip title="Don't have permission to delete">
                        <DeleteIcon className="delete-icon-disable" arrow />
                    </Tooltip>
                </>
        );
    };


    const columns = [
        {
            field: "firmwareVersion", headerName: "Firmware Version(s)", flex: 1,
            row: true, renderCell: (row) => renderVersionList(row, 'firmwareVersion'),
            sortDirection: false,
            disableSortIcon: true
        },
        {
            field: "kpiVersion", headerName: "KPI Version(s)", flex: 1,
            row: true, renderCell: (row) => renderVersionList(row, 'kpiVersion'),
            sortDirection: false,
            disableSortIcon: true
        },
        {
            field: "tvAppVersion", headerName: "TV App Version(s)", flex: 1,
            row: true, renderCell: (row) => renderVersionList(row, 'tvAppVersion'),
            sortDirection: false,
            disableSortIcon: true
        },
        {
            field: "bouquetNames", headerName: "Bouquet Name(s)", flex: 1,
            row: true, renderCell: (row) => renderVersionList(row, 'bouquetName'),
            sortDirection: false,
            disableSortIcon: true
        },
        {
            field: "actionCell",
            row: true,
            headerName: "Actions",
            flex: 0.5,
            renderCell: renderActionIcon,
            sortDirection: false,
            disableSortIcon: true,
        },
    ];

    const softwareStackDetailsList = () => {
        const apiPath = `software-versions-search?pageNo=1&recordsPerPage=10`;
        setLoader(true);
        callAPI(apiPath, "POST", {})
            .then((response) => {
                setSoftwareVersionResponse(response?.softwareVersionResponse);
                setLoader(false);
            })
            .catch((err) => { console.warn(err.message); setLoader(false); });
    };


    const cancelHotelHandler = () => {
        reset({
            firmwareVersion: [],
            kpiVersion: [],
            tvAppVersion: [],
            bouquetNames: [],
        });
        setEditSoftwareStatckSid({});
        setEditSoftwareStack(false);
    }

    const getSoftwareStackSidHandler = () => {
        setLoader(true);
        callAPI(`/software-versions?id=${editSoftwareStatckSid?.id}`, "GET")
            .then(function (response) {
                const payload = {
                    firmwareVersion: response?.firmwareVersion,
                    kpiVersion: response?.kpiVersion,
                    tvAppVersion: response?.tvAppVersion,
                    bouquetNames: response?.bouquetName,
                };
                reset(payload);
                setLoader(false);
            })
            .catch(function (error) {
                console.warn(error.response?.data?.errorMessage);
                setLoader(false);
            });
    }

    const resetLayoutHandler = () => {
        reset();
    }
    const popupCloseHandler = () => {
        setDeleteSoftwareStackPopUp(false);
    };
    useEffect(() => {
        softwareStackDetailsList();
    }, []);

    useEffect(() => {
        if (editSoftwareStack) {
            getSoftwareStackSidHandler();
        }
    }, [editSoftwareStack]);

    const cancelPopUpHandler = () => {
        setShowRowDataPopUp(false);
        setRowData([]);
        setRowKey('');
    }

    return (
        <div className='row config-hotel'>
            <div className='col-12 left-column'>
                <form autoComplete="off" onSubmit={handleSubmit(onSubmit)} className={`hotel-list-form ${editSoftwareStack ? "" : softwareVersionResponse?.length ? "page-mask" : ""} `}>
                    {softwareVersionResponse?.length !== 0 && !editSoftwareStack && <div className='mask-content default-config'>Only one master configuration can be created at a time. <br /> Please update existing one if required.</div>}
                    <div className="row">
                        <div className="left-column-header">
                            <p>Software Stack Details</p>
                        </div>

                        <div className="form-group-hotel col-6">
                            <div className="floating-select-label">
                                <Controller
                                    name="firmwareVersion"
                                    control={control}
                                    rules={{
                                        validate: (value) => {
                                            if (!Array.isArray(value) || value.length === 0) {
                                                return 'Please Enter Firmware Version';
                                            }
                                            for (let item of value) {
                                                if (typeof item !== 'string' || item.trim().length === 0) {
                                                    return 'Please enter firmware version';
                                                }
                                            }
                                            return true;
                                        },
                                    }}
                                    render={({ field }) => (
                                        <Autocomplete
                                            {...field}
                                            className={`multiselectlist ${field.value && field?.value?.length > 0 ? 'Mui-focused' : ''}`}
                                            limitTags={2}
                                            disablePortal
                                            multiple
                                            freeSolo
                                            open={false}
                                            options={watch('firmwareVersion')}
                                            getOptionLabel={(option) => option.toString()}
                                            onChange={(_, newValue) => {
                                                field.onChange(newValue);
                                            }}
                                            value={field.value || []}
                                            renderOption={(props, option) => (
                                                <li {...props} style={{ display: 'flex', alignItems: 'center' }}>
                                                    {option}
                                                    <IconButton
                                                        edge="end"
                                                        aria-label="remove"
                                                        style={{ marginLeft: 'auto' }}
                                                    >
                                                        <ClosedIcon />
                                                    </IconButton>
                                                </li>
                                            )}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder=""
                                                    variant="outlined"
                                                    label="Firmware Version"
                                                    InputLabelProps={{
                                                        shrink: false,
                                                    }}
                                                />
                                            )}
                                        />
                                    )}
                                />
                                {errors.firmwareVersion && (
                                    <p className="required text-start">{errors.firmwareVersion.message}</p>
                                )}
                            </div>
                        </div>
                        <div className="form-group-hotel col-6">
                            <div className="floating-select-label">
                                <Controller
                                    name="kpiVersion"
                                    control={control}
                                    rules={{
                                        validate: (value) => {
                                            if (!Array.isArray(value) || value.length === 0) {
                                                return 'Please Enter KPI Version';
                                            }
                                            for (let item of value) {
                                                if (typeof item !== 'string' || item.trim().length === 0) {
                                                    return 'Please Enter KPI Version';
                                                }
                                            }
                                            return true;
                                        },
                                    }}
                                    render={({ field }) => (
                                        <Autocomplete
                                            {...field}
                                            className={`multiselectlist ${field.value && field?.value?.length > 0 ? 'Mui-focused' : ''}`}
                                            limitTags={2}
                                            disablePortal
                                            multiple
                                            freeSolo
                                            open={false}
                                            options={watch('kpiVersion')}
                                            getOptionLabel={(option) => option.toString()}
                                            onChange={(_, newValue) => {
                                                field.onChange(newValue);
                                            }}
                                            value={field.value || []}
                                            renderOption={(props, option) => (
                                                <li {...props} style={{ display: 'flex', alignItems: 'center' }}>
                                                    {option}
                                                    <IconButton
                                                        edge="end"
                                                        aria-label="remove"
                                                        style={{ marginLeft: 'auto' }}
                                                    >
                                                        <ClosedIcon />
                                                    </IconButton>
                                                </li>
                                            )}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder=""
                                                    variant="outlined"
                                                    label="KPI Version"
                                                    InputLabelProps={{
                                                        shrink: false,
                                                    }}
                                                />
                                            )}
                                        />
                                    )}
                                />
                                {errors.kpiVersion && (
                                    <p className="required text-start">{errors.kpiVersion.message}</p>
                                )}
                            </div>
                        </div>
                        <div className="form-group-hotel col-6">
                            <div className="floating-select-label">
                                <Controller
                                    name="tvAppVersion"
                                    control={control}
                                    rules={{
                                        validate: (value) => {
                                            if (!Array.isArray(value) || value.length === 0) {
                                                return 'Please Enter TV App Version';
                                            }
                                            for (let item of value) {
                                                if (typeof item !== 'string' || item.trim().length === 0) {
                                                    return 'Please Enter TV App Version';
                                                }
                                            }
                                            return true;
                                        },
                                    }}
                                    render={({ field }) => (
                                        <Autocomplete
                                            {...field}
                                            className={`multiselectlist ${field.value && field?.value?.length > 0 ? 'Mui-focused' : ''}`}
                                            limitTags={2}
                                            disablePortal
                                            multiple
                                            freeSolo
                                            open={false}
                                            options={watch('tvAppVersion')}
                                            getOptionLabel={(option) => option.toString()}
                                            onChange={(_, newValue) => {
                                                field.onChange(newValue);
                                            }}
                                            value={field.value || []}
                                            renderOption={(props, option) => (
                                                <li {...props} style={{ display: 'flex', alignItems: 'center' }}>
                                                    {option}
                                                    <IconButton
                                                        edge="end"
                                                        aria-label="remove"
                                                        style={{ marginLeft: 'auto' }}
                                                    >
                                                        <ClosedIcon />
                                                    </IconButton>
                                                </li>
                                            )}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder=""
                                                    variant="outlined"
                                                    label="TV App Version"
                                                    InputLabelProps={{
                                                        shrink: false,
                                                    }}
                                                />
                                            )}
                                        />
                                    )}
                                />
                                {errors.tvAppVersion && (
                                    <p className="required text-start">{errors.tvAppVersion.message}</p>
                                )}
                            </div>
                        </div>
                        <div className="form-group-hotel col-6">
                            <div className="floating-select-label">
                                <Controller
                                    name="bouquetNames"
                                    control={control}
                                    rules={{
                                        validate: (value) => {
                                            if (!Array.isArray(value) || value.length === 0) {
                                                return 'Please Enter Bouquet Name';
                                            }
                                            for (let item of value) {
                                                if (typeof item !== 'string' || item.trim().length === 0) {
                                                    return 'Please Enter Bouquet Name';
                                                }
                                            }
                                            return true;
                                        },
                                    }}
                                    render={({ field }) => (
                                        <Autocomplete
                                            {...field}
                                            className={`multiselectlist ${field.value && field?.value?.length > 0 ? 'Mui-focused' : ''}`}
                                            limitTags={2}
                                            disablePortal
                                            multiple
                                            freeSolo
                                            open={false}
                                            options={watch('bouquetNames')}
                                            getOptionLabel={(option) => option.toString()}
                                            onChange={(_, newValue) => {
                                                field.onChange(newValue);
                                            }}
                                            value={field.value || []}
                                            renderOption={(props, option) => (
                                                <li {...props} style={{ display: 'flex', alignItems: 'center' }}>
                                                    {option}
                                                    <IconButton
                                                        edge="end"
                                                        aria-label="remove"
                                                        style={{ marginLeft: 'auto' }}
                                                    >
                                                        <ClosedIcon />
                                                    </IconButton>
                                                </li>
                                            )}
                                            renderInput={(params) => (
                                                <TextField
                                                    {...params}
                                                    placeholder=""
                                                    variant="outlined"
                                                    label="Bouquet Name"
                                                    InputLabelProps={{
                                                        shrink: false,
                                                    }}
                                                />
                                            )}
                                        />
                                    )}
                                />
                                {errors.bouquetNames && (
                                    <p className="required text-start">{errors.bouquetNames.message}</p>
                                )}
                            </div>
                        </div>
                        <div className="col-12 form-group-hotel text-end">
                            <button type="button" className="clear-btn me-2" onClick={cancelHotelHandler}>{editSoftwareStack ? "Cancel" : "Clear All"}</button>
                            {editSoftwareStack && <>
                                <button type="button" className="clear-btn me-2" onClick={resetLayoutHandler}>Reset</button>
                            </>}
                            <button type="submit" className={`create-btn`}>{editSoftwareStack ? "Update" : "Create"}</button>
                        </div>
                    </div>
                </form>
                <div className="hotel-list">
                    <p><b>Software Stack List</b></p>
                    <TableWrapper
                        data={softwareVersionResponse}
                        columns={columns}
                        module="stack-details"
                        noPagination={true}
                    />
                </div>
            </div>
            {softwareStackCreated !== "" && <BasicModal
                popupOpen={softwareStackCreated !== ""}
                logo={"/Images/approve-qc.png"}
                bodyMessage={<p className="mt-2">{softwareStackCreated}</p>}
                footer={
                    {
                        secondaryButton: {
                            buttonName: "OK",
                            action: () => { setSoftwareStackCreated(''); },
                            buttonPrimaryCustomCss: 'cancel-btn_new'
                        }
                    }
                }
            />}
            {deleteSoftwareStackPopUp && <BasicModal
                popupOpen={deleteSoftwareStackPopUp}
                bodyMessage={<>
                    <img src={deleteImg} alt="approve" className="w-40px" />
                    <div className="delete-hotel">{isHotelDeletedRef.current?.isHotelDeletedModalData ?
                        <div className="confirm-delete-hotel">
                            <p>Do you really want to Delete?</p>
                            <p className="warning"><IoMdWarning /> Warning</p>
                            <p> Will be permanently deleted <br />
                                Deleting the specified Record can't be undone.
                            </p>
                            <p className="mt-3">To confirm deletion, type "Delete"</p>
                            <div className="form-group-hotel mt-3">
                                <div className="floating-label">
                                    <input
                                        id="deleteHotel"
                                        placeholder=""
                                        onChange={(e) => setConfirmDeleteHotel(e.target.value)}
                                    />
                                    <label htmlFor="address">Delete</label>
                                </div>
                                {(confirmDeleteHotel === "" && confirmValidate) ? (
                                    <small className="required">Please Enter Delete</small>
                                ) : confirmValidate ? (
                                    <small className="required">Please Enter Delete</small>
                                ) : ""
                                }
                            </div>
                        </div> :
                        isHotelDeletedRef.current?.userConformationModalData?.successMessage}</div>
                </>
                }
                footer={
                    isHotelDeletedRef.current?.isHotelDeletedModalData ?
                        {
                            primaryButton: {
                                buttonName: "Cancel",
                                action: popupCloseHandler
                            }
                            ,
                            secondaryButton: {
                                buttonName: "Delete",
                                action: deleteHotelHandler
                            }
                        } : {
                            secondaryButton: {
                                buttonName: "OK",
                                action: popupCloseHandler
                            }
                        }
                }
            />}
            {showRowDataPopUp && <BasicModal
                popupOpen={showRowDataPopUp}
                bodyMessage={
                    <div className="text-start">
                        <div className="linked-sid-cdsns">
                            <div className="sid-cdsn-list">
                                <div className="row sid-cdsn-list-header">
                                    <h6 className="text-start text-capitalize">{rowKey}</h6>
                                </div>
                                <div className="my-3 px-3">
                                    {rowData?.map((items, index) =>
                                        <span className="mb-1">{index ? ', ' : ''} {items}</span>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                }
                customcss={true}
                footer={
                    {
                        primaryButton: {
                            buttonName: "Cancel",
                            action: cancelPopUpHandler,
                            buttonPrimaryCustomCss: 'cancel-btn_new'
                        }
                    }
                }
            />
            }
        </div>
    )
}

export default SoftwareStackDetails;